import { TmApiValidationError } from '@/core/error/transport/tmApiValidationError'

export class TmFileUploadMaxSizeError extends TmApiValidationError {
  public name = 'TmFileUploadMaxSizeError'
}
